<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px" class="m1">
	<mat-spinner [diameter]="20"></mat-spinner>
	<span>{{ loadingMessage }}</span>
</div>
